import React from "react";
import { iconConfig, baseIconStyle } from "./iconConfig";

const IconResolver = ({
  name,
  color,
  size,
  style,
  fallback = "file", // 🔥 fallback padrão
  ...rest
}) => {
  const cfg = iconConfig[name] || iconConfig[fallback];

  if (!cfg) return null; // segurança extra

  const IconComponent = cfg.component;

  const finalStyle = {
    ...baseIconStyle,
    ...cfg.style,
    ...(color ? { color } : {}),
    ...(size ? { fontSize: size } : {}),
    ...style,
  };

  return <IconComponent style={finalStyle} {...rest} />;
};

export default IconResolver;
